import { render, staticRenderFns } from "./PreferencesAccount.vue?vue&type=template&id=56734926"
import script from "./PreferencesAccount.vue?vue&type=script&lang=js"
export * from "./PreferencesAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports